// apps/web/src/components/visitors/VisitorCard/modes/CompactMode.tsx
import React from 'react';
import { Box } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { Visitor, ActiveSubscriptionInfo } from '@gym-management/shared';
import VisitorAvatar from '../VisitorAvatar';
import VisitorInfo from '../VisitorInfo';
import VisitorStatusChips from '../VisitorStatusChips';

interface CompactModeProps {
  visitor: Visitor;
  isCheckedIn: boolean;
  hasActiveSubscription?: boolean;
  activeSubscription?: ActiveSubscriptionInfo;
  onViewDetails?: (visitor: Visitor) => void;
}

const CompactMode: React.FC<CompactModeProps> = ({
  visitor,
  isCheckedIn,
  hasActiveSubscription,
  activeSubscription,
  onViewDetails,
}) => {
  const theme = useTheme();

  const handleCardClick = () => {
    if (onViewDetails) onViewDetails(visitor);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        p: 0.75,
        width: '100%',
        cursor: onViewDetails ? 'pointer' : 'default',
        borderRadius: 1,
        '&:hover': onViewDetails
          ? {
              backgroundColor: alpha(theme.palette.primary.main, 0.04),
            }
          : {},
      }}
      onClick={handleCardClick}
    >
      <VisitorAvatar
        photoUrl={visitor.photoUrl}
        name={visitor.name}
        isActive={visitor.active}
        size="small"
        sx={{ borderWidth: '1.5px' }}
      />

      <VisitorInfo name={visitor.name} phone={visitor.phone} variant="compact" />

      <Box
        sx={{
          width: '45%',
          minWidth: '160px',
          flexShrink: 0,
          ml: 'auto',
        }}
      >
        <VisitorStatusChips
          hasActiveSubscription={hasActiveSubscription}
          isActive={visitor.active}
          isCheckedIn={isCheckedIn}
          variant="compact"
          subscriptionName={activeSubscription?.subscriptionTypeName}
          remaining={activeSubscription?.subscriptionTypeRemaining}
          subscriptionType={activeSubscription?.subscriptionTypeType}
          totalCount={activeSubscription?.subscriptionTypeCount}
          endDate={activeSubscription?.endDate}
        />
      </Box>
    </Box>
  );
};

export default CompactMode;
